import React from "react";

function Libra() {
  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 496.158 496.158"
      enableBackground="new 0 0 496.158 496.158"
    >
      <path
        fill="#F9DC5F"
        d="M248.082,0.003C111.07,0.003,0,111.063,0,248.085c0,137.001,111.07,248.07,248.082,248.07
	c137.006,0,248.076-111.069,248.076-248.07C496.158,111.062,385.088,0.003,248.082,0.003z"
      />
      <g>
        <rect x="243.029" y="157.629" fill="#4C4C48" width="10.938" height="202.92" />
        <path
          fill="#4C4C48"
          d="M268.272,386.501c0-46.279-19.353-45.438-19.353-45.438s-19.353-0.842-19.353,45.438
		c0,0,5.049,17.67-78.253,17.67v8.414h195.211v-8.414C263.225,404.171,268.272,386.501,268.272,386.501z"
        />
        <path
          fill="#4C4C48"
          d="M248.499,123.134c-4.628,0-10.813,9.808-10.813,31.73s22.467,21.922,22.467,0
		C260.153,132.941,253.127,123.134,248.499,123.134z"
        />
      </g>
      <g>
        <path
          fill="#6D6D68"
          d="M369.949,191.075c-1.718-0.696-3.685,0.13-4.385,1.853l-36.903,111.909
		c-0.594,1.723,0.109,3.686,1.569,4.385c0.352,0.169,0.714,0.248,1.072,0.248c1.126,0,2.193-0.793,2.645-2.1l37.854-111.91
		C372.501,193.737,371.672,191.774,369.949,191.075z"
        />
        <path
          fill="#6D6D68"
          d="M423.451,304.837l-36.925-111.909c-0.7-1.723-2.667-2.549-4.385-1.853
		c-1.723,0.699-2.552,2.662-1.853,4.385l37.877,111.91c0.449,1.307,1.517,2.1,2.644,2.1c0.357,0,0.721-0.079,1.073-0.248
		C423.342,308.522,424.044,306.559,423.451,304.837z"
        />
        <path
          fill="#6D6D68"
          d="M327.975,304c0,0,0.714,48.485,48.497,48.485S424.255,304,424.255,304L327.975,304L327.975,304z"
        />
      </g>
      <path
        fill="#4C4C48"
        d="M386.404,170.553c-0.007,0.033-0.02,0.066-0.027,0.101c-1.459-2.901-4.23-5.341-7.836-6.499
	c-6.525-2.098-13.289,0.783-15.104,6.432c-1.816,5.651,2.002,11.932,8.527,14.028c0.158,0.051,0.316,0.086,0.474,0.131
	c-3.192,0.753-6.618,0.694-9.968-0.383c-4.939-1.588-13.397-11.229-31.094-16.917c-14.019-4.506-45.148-5.23-85.213-18.106
	l-4.248,13.218c32.111,10.32,64.651,10.515,78.967,14.627c26.484,7.608,32.892,14.99,39.777,20.148
	c6.885,5.159,23.311,3.092,27.221-9.075C389.844,182.152,389.134,175.831,386.404,170.553z"
      />
      <g>
        <path
          fill="#6D6D68"
          d="M168.885,224.837l-38.291-111.909c-0.7-1.723-2.667-2.549-4.385-1.853
		c-1.723,0.699-2.552,2.662-1.853,4.385l39.088,111.91c0.463,1.307,1.562,2.1,2.721,2.1c0.368,0,0.742-0.079,1.104-0.248
		C168.771,228.522,169.494,226.559,168.885,224.837z"
        />
        <path
          fill="#6D6D68"
          d="M114.017,111.075c-1.718-0.696-3.685,0.13-4.385,1.853L71.323,224.837
		c-0.611,1.723,0.112,3.686,1.615,4.385c0.362,0.169,0.735,0.248,1.104,0.248c1.159,0,2.258-0.793,2.722-2.1l39.104-111.91
		C116.568,113.737,115.739,111.774,114.017,111.075z"
        />
        <path fill="#6D6D68" d="M70.495,224c0,0,0,48.485,49.18,48.485c49.181,0,49.914-48.485,49.914-48.485H70.495z" />
      </g>
      <path
        fill="#4C4C48"
        d="M166.357,114.409c-17.696-5.688-30.188-2.778-35.127-4.366c-3.35-1.076-6.168-3.024-8.324-5.496
	c0.154,0.055,0.303,0.119,0.461,0.17c6.525,2.097,13.288-0.782,15.104-6.434c1.816-5.648-2.002-11.93-8.527-14.026
	c-3.605-1.159-7.281-0.793-10.156,0.717c0.014-0.033,0.023-0.067,0.037-0.099c-5.294,2.7-9.555,7.424-11.516,13.529
	c-3.91,12.166,8.236,23.416,16.838,23.234c8.602-0.18,18.109-2.447,44.066,6.8c14.031,4.997,40.592,23.797,72.703,34.118
	l4.248-13.218C206.1,136.462,180.377,118.915,166.357,114.409z"
      />
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
    </svg>
  );
}

export default Libra;
